import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';

export type saveData = {
    id?: any;
  };
  
  export const deleteCity = ({
   id
  }: saveData) => {
        return axios.delete(`/superAdmin/delete-city/${id}`);
    
  };
  
  type UseAddPetOptions = {
    config?: MutationConfig<typeof deleteCity>;
  };
  
  export const useDeleteCity = ({ config }: UseAddPetOptions = {}) => {
    return useMutation({
      onSuccess: (res: any, req: any) => {
        showNotification({
          type: 'success',
          title: 'City deleted successfully.',
        });
      },
      ...config,
      mutationFn: deleteCity,
    });
  };
  
